module.exports = __webpack_public_path__ + "img/bg-login-cities.db8035d7.jpg";